import React from 'react'

export function HelpScoutArrowIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8001 11.9995C16.8001 11.2995 16.5301 10.5995 16.0001 10.0695L9.48014 3.54953C9.19014 3.25953 8.71014 3.25953 8.42014 3.54953C8.13014 3.83953 8.13014 4.31953 8.42014 4.60953L14.9401 11.1295C15.4201 11.6095 15.4201 12.3895 14.9401 12.8695L8.42014 19.3895C8.13014 19.6795 8.13014 20.1595 8.42014 20.4495C8.71014 20.7395 9.19014 20.7395 9.48014 20.4495L16.0001 13.9295C16.5301 13.3995 16.8001 12.6995 16.8001 11.9995Z"
        fill="rgb(var(--background-secondary))"
      />
    </svg>
  )
}
